/* global module, require */
const classnames = require('classnames'),
	crel = require('./createElement'),
	empty = require('./emptyElement');

function PlannerStyles(parent, data) {
	this.name = 'Style';
	this.parent = parent;
	this.single = true;

	if (data) {
		const style = parent.planner.styles.filter(s => s.name === data)[0];
		if (style) parent.planner.changeStyle(style);
	}
}

PlannerStyles.prototype.activate = function() {
	var { content, planner } = this.parent;
	empty(content);

	var container = crel({
		_parent: content,
		className: 'planner-choose-style',
	});
	crel({
		_parent: container,
		_tag: 'h2',
		innerText: 'Please select your style of barrier',
	});
	var choices = crel({ _parent: container, className: 'choices' });
	var wrapper = crel({ _parent: choices, className: 'wrapper' });

	var buttons = planner.styles.map(style => {
		var button = crel({
			_tag: 'button',
			_parent: wrapper,
			className: classnames('style', { active: planner.style === style }),
			onclick: () => {
				buttons.forEach(btn => {
					if (btn === button) btn.classList.add('active');
					else btn.classList.remove('active');
				});
				planner.changeStyle(style);
			},
		});

		if (style.image) crel({ _tag: 'img', _parent: button, src: style.image });
		crel({ _parent: button, innerText: style.name, className: 'name' });

		return button;
	});
};

PlannerStyles.prototype.complete = function() {
	return true;
};

module.exports = PlannerStyles;
